import {createSlice} from '@reduxjs/toolkit';
import {initialUrl} from 'src/shared/constants/AppConst';
import {ThemeDirection} from 'src/shared/constants/AppEnums';
import {UserDeatilsDto} from 'src/shared/services/users-management/dto/details-user-dto';

interface AuthInitialState {
  visibleLogout?: boolean;
  visibleChangePassword?: boolean;
  loading?: boolean;
  isAuthenticated?: boolean;
  dircation?: string;
  initialUrl: string;
  myPermissions?: Array<string>;
  myProfile?: UserDeatilsDto;
  isMyProfileLoading: boolean;
}
// logout, loading ,isAuthenticated
const initialState: AuthInitialState = {
  visibleLogout: false,
  visibleChangePassword: false,
  loading: false,
  isAuthenticated: false,
  dircation: ThemeDirection.LTR,
  initialUrl: initialUrl,
  myPermissions: [],
  myProfile: undefined,
  isMyProfileLoading: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState: initialState,
  reducers: {
    setVisibleLogout: (state, action) => {
      state.visibleLogout = action.payload;
    },
    setVisibleChangePassword: (state, action) => {
      state.visibleChangePassword = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setAuthenticated: (state, action) => {
      state.isAuthenticated = action.payload;
    },
    setDirection: (state, action) => {
      state.dircation = action.payload;
    },
    setInitialUrl: (state, action) => {
      state.initialUrl = action.payload;
    },
    setMyPermissions: (state, action) => {
      state.myPermissions = action.payload;
    },
    setMyProfile: (state, action) => {
      state.myProfile = action.payload;
    },
    setIsMyProfileLoading: (state, action) => {
      state.isMyProfileLoading = action.payload;
    },
  },
});

export const {
  setVisibleLogout,
  setVisibleChangePassword,
  setLoading,
  setAuthenticated,
  setDirection,
  setInitialUrl,
  setMyPermissions,
  setMyProfile,
  setIsMyProfileLoading,
} = authSlice.actions;
export default authSlice.reducer;
